import { Route } from '@angular/router';
import { Registration } from '@features/registration/registration';
import { Page404 } from '@features/page404/page404';

export const APP_ROUTE: Route[] = [
  { path: '', redirectTo: '/registration', pathMatch: 'full' },
  { path: 'registration', component: Registration },
  {
    path: '404',
    component: Page404,
  },

  //not found
  {
    path: '**',
    component: Page404,
  },
];
